import { render } from "./ExampleSquare.vue?vue&type=template&id=602d312c&scoped=true"
import script from "./ExampleSquare.vue?vue&type=script&lang=js"
export * from "./ExampleSquare.vue?vue&type=script&lang=js"

import "./ExampleSquare.vue?vue&type=style&index=0&id=602d312c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602d312c"]])

export default __exports__